{
  "id": "natureza-juridica",
  "nome": "RFB CNPJ Naturezas Jurídicas",
  "fonte": "Receita Federal — Dados Abertos CNPJ (Naturezas.zip)",
  "endpoints": [
    "https://github.com/jonathands/dados-abertos-receita-cnpj/releases/download/2024.09/Naturezas.zip"
  ],
  "capturadoEm": "2026-08-11",
  "atualizadoEm": "2026-08-11T05:28:15.704Z",
  "contagens": {
    "naturezas": 90
  },
  "alteracoes": {
    "adicionados": 0,
    "removidos": 0,
    "alterados": 0,
    "comparadoCom": "2026-08-05"
  },
  "verificacao": {
    "agendamento": "diario",
    "workflow": "data-refresh-bot.yml",
    "ultimaExecucao": "2026-08-11T05:28:15.704Z"
  },
  "documentacao": "docs/OFFICIAL-SOURCES.md#natureza-juridica"
}
